



const textFilter = (options, searchText, key, type) => {

    const filteredData = options.filter((item) => {
        if(type === "nakliyeHesaplama"){
            return item[key]?.toLocaleLowerCase("tr").startsWith(searchText?.toLocaleLowerCase("tr"))
        }
        else{
            return item[key]?.toLocaleLowerCase("tr").includes(searchText?.toLocaleLowerCase("tr"))
        }
    })

    return filteredData
}

export default textFilter